import D2C_ProviderStorage from './Storage'

class D2C_ProviderS3 extends D2C_ProviderStorage {
  static objectType = 'providerType'
  static active = true
  static order = 35
  static providerType = 'S3'
  static providerTitle = 'Amazon S3'
  static fields = {
    ...D2C_ProviderStorage.fields,
    bucket: {
      default: '',
      label: 'Bucket',
      path: 'auth.bucket',
      required: true,
      validate() {
        return null
      },
      creating: {},
    },
    secretKey: {
      default: '',
      label: 'Secret key',
      path: 'auth.secretKey',
      required: true,
      validate(value) {
        return /^[A-Za-z0-9/+=]{40}$/.test(value) ? null : 'Must contain 40 symbols'
      },
      creating: {},
    },
    accessId: {
      default: '',
      label: 'Access ID',
      path: 'auth.accessId',
      required: true,
      validate(value) {
        return /^[A-Z0-9]{20}$/.test(value) ? null : 'Must contain 20 symbols'
      },
      creating: {},
    },
    region: {
      enum: [
        'ap-northeast-1',
        'ap-northeast-2',
        'ap-south-1',
        'ap-southeast-1',
        'ap-southeast-2',
        'ca-central-1',
        'eu-central-1',
        'eu-west-1',
        'eu-west-2',
        'eu-west-3',
        'sa-east-1',
        'us-east-1',
        'us-east-2',
        'us-west-1',
        'us-west-2',
      ],
      label: 'Region',
      path: 'auth.region',
      required: true,
      width: 8,
      validate(value) {
        return value ? null : 'Must be selected'
      },
      creating: {},
    },
    class: {
      default: 'STANDARD',
      enum: [
        {value: 'STANDARD', text: 'Standard'},
        {value: 'STANDARD_IA', text: 'Standard Infrequent Access'},
        {value: 'REDUCED_REDUNDANCY', text: 'Reduced Redundancy'},
      ],
      label: 'Backup class',
      path: 'auth.class',
      required: false,
      width: 8,
      validate() {
        return null
      },
      creating: {},
    },
  }
  get _backupPostfix() {
    return `-${this.auth.region}`
  }
}

export default D2C_ProviderS3
